<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="backButtonRoute"
    ref="sundry-receipt"
    :data-model="dataModel"
    :backRouteAppend="undefined"
    :isLoaded="loaded"
    :getHeaderToolbar="getHeaderToolbar"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import { mapGetters } from "vuex";

import { CustomerService } from "../../_services/api/customers/customer.service";
import { BankAccountsServices } from "../../_services/api/finance/bankAccounts";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { getFactorByCode } from "../../_store/helpers";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      IsSettlementDateEnforced: undefined,
      CheckStockWriteOff: false,
      loaded: false,
      setLoading: false,

      dataModel: {
        Code: undefined,
        BankAccountName: undefined,
        BankAccountCode: undefined,
        BSBNO: undefined,
        BSBNOBankAccountCode: undefined,
        Currency: undefined,
        CustomerName: undefined,
        DateIn: undefined,
        PayeeName: undefined,
        PaymentMethod: undefined,
        TaxAmount: undefined,
        IsGSTReportable: false,
        IncTaxAmount: undefined,
        BranchCode: undefined,
        DivisionCode: undefined,
        Status: undefined,

        CurrencyCode: "FX",
      },
    };
  },

  async created() {},
  async mounted() {
    this.$store.dispatch("dataContext/setReviewDataSource", []);
    this.initialized();
  },
  beforeDestroy() {},

  computed: {
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    backButtonRoute() {
      return (
        "/bank-accounts-transaction/review/" + this.dataModel.BankAccountCode
      );
    },
    // this.dataModel.BankAccountCode

    getScreenJson() {
      var screenJson = {
        title: "Sundry Receipt",
        endpoint: this.isReviewMode()
          ? {
              primary: "SundryReceipt",
              postProcess: this.sundryreceiptPostProcess,
            }
          : { primary: undefined },
        headerData: {
          headerToolbar: {
            screenName: "Sundry receipt",
            pdf: false,
            audit: true,
            status: true,
            notes: false,

            auditItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Created By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {},
                  },
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Changed By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {},
                  },
                ],
              },
            ],
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DateIn",
                      dataField: "DateIn",
                      label: {
                        text: "Date",
                      },
                    },
                    {
                      label: {
                        text: "Customer",
                      },
                      dataField: "CustomerName",
                    },
                    {
                      screenField: "PayeeName",
                    },
                    {
                      dataField: "PaymentMethod",
                      label: "PaymentMethod",
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "Branch",
                      dataField: "BranchCode",
                      label: {
                        text: "Branch",
                      },
                      dataSourceConfig: {
                        endpoint: "api/Branch",
                        sort: {
                          selector: "Description",
                          asc: true,
                        },
                      },
                    },
                    {
                      screenField: "Division",
                      dataField: "DivisionCode",
                      label: {
                        text: "Division",
                      },
                      dataSourceConfig: {
                        endpoint: "api/Division",
                        sort: {
                          selector: "Description",
                          asc: true,
                        },
                      },
                    },
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 2,
                      items: [
                        {
                          screenField: "Currency",
                        },
                        {
                          screenField: "ExchangeRate",
                          dataField: "ExchangeRate",
                        },
                      ],
                    },

                    {
                      dataField: "IsGSTReportable",

                      editorType: "dxCheckBox",
                      label: {
                        text: "BAS Reportable",
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      screenField: "FXAmount",
                      dataField: "FXAmount",
                      label: {
                        text: `Amount (${this.dataModel.CurrencyCode})`,
                      },
                    },
                    {
                      screenField: "TaxTotal",
                      dataField: "FXTaxAmount",

                      label: {
                        text: `Tax (${this.dataModel.CurrencyCode})`,
                      },
                    },
                    {
                      screenField: "FXAmount",
                      dataField: "IncTaxAmount",
                      label: {
                        text: "Amount (" + this.getCurrencyCode + ")",
                      },
                      visible:
                        this.getCurrencyCode != this.dataModel.CurrencyCode,
                    },
                    {
                      screenField: "TaxTotal",
                      dataField: "TaxAmount",

                      label: {
                        text: "Tax (" + this.getCurrencyCode + ")",
                      },
                      visible:
                        this.getCurrencyCode != this.dataModel.CurrencyCode,
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: this.baseView.mode == "create" ? undefined : "Code",
                text: "Sundry Receipt ",
              },
              secondary: {
                dataField:
                  this.baseView.mode == "create"
                    ? "Customer"
                    : "BankAccountName",
                text: this.baseView.mode == "create" ? undefined : " to ",
              },
            },
            secondary: {
              dataField: "BSBNOBankAccountCode",
              text: "",
            },
          },
        },
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SundryReceiptDetail",
              filter: ["SundryReceiptCode eq " + this.baseView.id],
              serverPaging: true,
              allowGrouping: false,
              // expand: "SaleItem",
              postProcessCallback: this.CashReceiptDetailPostProcess,
            },
          },
          toolbar: {
            search: false,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
            review: false,
          },
          columns: [
            {
              screenField: "Account",
              label: "Account",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "AccountCode",
                  },
                ],
                secondary: [
                  {
                    dataField: "",
                  },
                ],
              },
            },

            {
              screenField: "Comments",
              label: "Comment",
              dataField: "Comment",
            },
            {
              screenField: "FXAmount",
              label: `Amount (${this.dataModel.CurrencyCode})`,
              dataField: "FXAmount",
            },
            {
              screenField: "FXAmount",
              label: "Amount (Base Currency)",
              dataField: "Amount",
              visible: this.getCurrencyCode != this.dataModel.CurrencyCode,
            },
          ],

          valueChangedEventListners: [],
        },
        footerData: {
          footerItems: [
            {
              screenField: "FXTotal",
              location: "right",
              value: 0,
              dataField: "FXAmount",
              label: "Sub Total(" + this.dataModel.CurrencyCode + ")",
              customCalc: (headerData, gridItems) => {
                var total = 0;
                gridItems.forEach((element) => {
                  total = total + element.FXAmount;
                });

                return total;
              },
            },
            {
              screenField: "FXTotal",
              location: "right",
              label: "Tax(" + this.dataModel.CurrencyCode + ")",
              value: 0,
              allowEditing: false,
              customCalc: (headerData) => {
                return headerData.FXTaxAmount;
              },
            },
            {
              screenField: "FXTotal",
              location: "right",

              value: 0,
              customCalc: (headerData, gridItems) => {
                var total = 0;
                gridItems.forEach((element) => {
                  total = total + element.FXAmount;
                });
                var Balance = headerData.FXTaxAmount + total;

                return Balance;
              },

              label: "Total (" + this.dataModel.CurrencyCode + ")",
            },
            {
              screenField: "FXTotal",
              location: "right",

              value: 0,
              customCalc: (headerData, gridItems) => {
                var total = 0;
                gridItems.forEach((element) => {
                  total = total + element.Amount;
                });
                var Balance = headerData.TaxAmount + total;

                return Balance;
              },

              label: "Total (" + this.getCurrencyCode + ")",
              visible: this.getCurrencyCode != this.dataModel.CurrencyCode,
            },
          ],
        },
      };
      return screenJson;
    },
    getCurrencyCode() {
      if (this.dataModel.Currency) return this.dataModel.Currency;
      else return "";
    },

    getHeaderToolbar() {
      return {
        headerToolbar: {
          screenName: " ",
          pdf: false,
          audit: true,
          status: true,
          notes: false,
          save: false,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {},
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {},
                },
              ],
            },
          ],
        },
      };
    },
  },
  methods: {
    isReviewMode() {
      return this.baseView.mode === "review";
    },
    async sundryreceiptPostProcess(data) {
      this.dataModel.Code = data.Code;
      this.dataModel.BankAccountCode = data.BankAccountCode;
      // this.dataModel.Bsbno = data.Bsbno;

      this.dataModel.DateIn = data.DateIn;
      this.dataModel.PayeeName = data.PayeeName;
      this.dataModel.PaymentMethod = data.PaymentMethod;
      this.dataModel.TaxAmount = data.TaxAmount;
      this.dataModel.IsGSTReportable = data.IsGstReportable;
      this.dataModel.IncTaxAmount = data.IncTaxAmount;
      this.dataModel.BranchCode = data.BranchCode;
      this.dataModel.DivisionCode = data.DivisionCode;
      this.dataModel.Status = data.FriendlyStatus;
      this.dataModel.FXAmount = data.FXAmount;
      this.dataModel.FXTaxAmount = data.FXTaxAmount;
      this.dataModel.ExchangeRate = data.ExchangeRate;

      this.dataModel.DateCreated = data.DateInto;
      this.dataModel.ChangedBy = data.CreatedBy;
      this.dataModel.DateChanged = data.DateInto;

      if (data.CurrencyCode) this.dataModel.CurrencyCode = data.CurrencyCode;

      await BankAccountsServices.getBankRecordByCode(data.BankAccountCode).then(
        async (response) => {
          if (response.data.value.length > 0) {
            this.dataModel.BankAccountName = response.data.value[0].AccountName;
            this.dataModel.Bsbno = response.data.value[0].BsbNo;
          }
        }
      );

      await CustomerService.getByCode(data.CustomerCode).then(
        async (response) => {
          if (response.data.value.length > 0) {
            this.dataModel.CustomerName = response.data.value[0].Name;
          }
        }
      );

      await CompanyService.getByCompanyCode(getFactorByCode(18).Factorc).then(
        (res) => {
          this.dataModel.Currency = res.data.value[0].CurrencyCode;
        }
      );
      this.dataModel.BSBNOBankAccountCode =
        this.dataModel.Bsbno + " " + data.BankAccountNo;

      return data;
    },

    async initialized() {
      this.setLoading = true;

      this.loaded = true;
      await this.$store.dispatch("screenFactors/getFactors", [18]);
    },
  },
};
</script>
